import 'nightingale-app-console/src';
import Alp from 'alp-node/src';
import router from 'alp-limosa/src';
import bodyparser from 'alp-body-parser/src';
import routerBuilder from './routerBuilder';
import controllers from './modules/controllers';

if (!process.send) {
  // eslint-disable-next-line no-console
  console.log('Not forked.');
  process.exit(1);
}

const app = new Alp();

// init / config
bodyparser(app);

app.catchErrors();
app.servePublic();
app.use(router(routerBuilder, controllers)(app));

app.start(async () => {
  await app.listen();
});
